import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { CandidateApplication } from '../core/agency/interfaces/candidate.interface';

@Injectable({
  providedIn: 'root',
})
export class MissionFragmentCandidatureService {
  private baseUrl = `${environment.api.BASE_URL}/api/mission-fragment-candidatures`;

  constructor(private http: HttpClient) {}

  /**
   * Accept mission fragments
   * @param fragmentIds List of fragment IDs to accept
   * @returns Observable with updated candidature data
   */
  acceptFragment(fragmentIds: number[]): Observable<any> {
    return this.http.post(`${this.baseUrl}/accept`, fragmentIds);
  }

  /**
   * Refuse mission fragments
   * @param fragmentIds List of fragment IDs to refuse
   * @returns Observable with updated candidature data
   */
  refuseFragment(fragmentIds: number[]): Observable<any> {
    return this.http.post(`${this.baseUrl}/refuse`, fragmentIds);
  }

  /**
   * Cancel accepted mission fragments
   * @param fragmentIds List of fragment IDs to cancel
   * @returns Observable with void response
   */
  cancelAcceptedFragment(fragmentIds: number[]): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/cancel-accepted`, fragmentIds);
  }

  /**
   * Cancel signed mission fragments
   * @param fragmentIds List of fragment IDs to cancel
   * @returns Observable with void response
   */
  cancelSignedFragment(fragmentIds: number[]): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/cancel-signed`, fragmentIds);
  }

  /**
   * Get candidatures by mission ID
   * @param missionId Mission ID
   * @returns Observable with candidature data
   */
  getCandidaturesByMission(missionId: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/mission/${missionId}`);
  }

  /**
   * Get candidatures by candidat ID
   * @param candidatId Candidat ID
   * @returns Observable with candidature data
   */
  getCandidaturesByCandidat(candidatId: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/candidat/${candidatId}`);
  }

  /**
   * Get fragments by mission ID with candidates
   * @param missionId Mission ID
   * @returns Observable with fragments and candidates data
   */
  getFragmentsByMission(missionId: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/fragments-by-mission/${missionId}`);
  }
}